import './ccf-agent-leg-disconnected-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Component used to display  agent leg disconnected icon
 * @param props - SvgIconProps
 * @example - <CcfAgentLegDisconnectedIcon />
 * @returns SVG of agent leg disconnected Icon
 */
export function CcfAgentLegDisconnectedIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 32 24" {...props}>
      <svg id="agent-leg-disconnected">
        <path
          id="Path_30423"
          data-name="Path 30423"
          d="M14.321,2.654,13.143,3.831a2.514,2.514,0,0,1-.255,3.182L7.081,12.885a2.514,2.514,0,0,1-3.564,0L2.4,11.755a2.514,2.514,0,0,1,0-3.564L8.226,2.383A2.482,2.482,0,0,1,9.42,1.731L11.011.139A4.153,4.153,0,0,0,7.049,1.206L1.225,7.029a4.169,4.169,0,0,0,0,5.9l1.13,1.13a4.169,4.169,0,0,0,5.9,0l5.824-5.824A4.153,4.153,0,0,0,14.321,2.654Z"
          transform="translate(0 -0.006)"
          fill={props.fill}
        />
        <path
          id="Path_30424"
          data-name="Path 30424"
          d="M22.953,18.1l1.13-1.13a4.169,4.169,0,0,0,0-5.9L18.259,5.241A4.153,4.153,0,0,0,12.69,4.97l1.177,1.177a2.514,2.514,0,0,1,3.182.271l5.856,5.808a2.514,2.514,0,0,1,0,3.564l-1.13,1.13a2.514,2.514,0,0,1-3.564,0L12.387,11.1A2.5,2.5,0,0,1,11.7,9.84L10.112,8.248a4.153,4.153,0,0,0,1.066,3.994L17,18.066a4.169,4.169,0,0,0,5.951.032Z"
          transform="translate(5.895 2.371)"
          fill={props.fill}
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfAgentLegDisconnectedIcon;
